import Overlay from './Overlay';
import axios from 'axios';
import {
  serialize
} from '../lib/helper';

export default class Reminder extends Overlay {

  constructor(el) {

    super(el);

    this.setReminderForm = this.overlay.content.querySelector('form');
    this.inputProductId = this.setReminderForm.querySelector('input[name="id"]');
    this.inputProductTitle = this.setReminderForm.querySelector('input[name="title"]');
    this.inputProductDisplayType = this.setReminderForm.querySelector('input[name="displayType"]');
    this.messageElement = this.overlay.content.querySelector('.response-message');

    this.action = this.setReminderForm.action;
    this.method = this.setReminderForm.method;
    this.productInformations = JSON.parse(this.el.getAttribute('data-product'));
    this.setReminderHandler = this.setReminder.bind(this);

    //tc-overlay-close
    document.addEventListener('tc-overlay-close', this.reset.bind(this), false);
    this.el.addEventListener('click', this.onClick.bind(this), false);
  }

  onClick() {

    this.inputProductId.value = this.productInformations.id;
    this.inputProductTitle.value = this.productInformations.title;
    this.inputProductDisplayType.value = this.productInformations.displayType;
    this.setReminderForm.addEventListener('submit', this.setReminderHandler, false);
  }

  setReminder(e) {

    e.preventDefault();

    if (window.tcLoader) {

      window.tcLoader.setActive();
    }

    axios({
      method: this.method,
      url: this.action,
      data: serialize(this.setReminderForm, true),
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(res => {

      if (window.tcLoader) {

        window.tcLoader.setInactive();
      }
      if (res.data.success) {

        this.overlay.close(e);
      } else {

        if (this.messageElement) {

          this.messageElement.innerHTML = res.data.message;
        }
      }

    })
    .catch(error => {

      if (window.tcLoader) {

        window.tcLoader.setInactive();
      }
      throw new Error(`Reminder.js, can't set reminder for this product: ${error.message}`);
    });
  }

  reset() {

    this.inputProductId.value = '';
    this.inputProductTitle.value = '';
    this.inputProductDisplayType.value = '';
    this.messageElement.innerHTML = '';
    this.setReminderForm.removeEventListener('submit', this.setReminderHandler, false);
  }
};
